import { updateOrgId } from '@canvas/canvas-state/org-data';
import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';

export const initializeCanvasListeners = () => {
  waitForContentAPI().then((canvasFrameAPI) => {
    canvasFrameAPI?.onOrgIdChange?.(updateOrgId);
  });
};
